module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 186);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputLabel = __webpack_require__(187);

var _InputLabel2 = _interopRequireDefault(_InputLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _InputLabel2.default;

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InputLabel;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _TickSmall = __webpack_require__(37);

var _TickSmall2 = _interopRequireDefault(_TickSmall);

var _general = __webpack_require__(188);

var _general2 = _interopRequireDefault(_general);

var _weight = __webpack_require__(189);

var _weight2 = _interopRequireDefault(_weight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Input labels don't have any font styles built in, so they will inherit
 * whatever is set on the parent container. An optional tick is displayed when
 * the input has validated in a form (on submit) with the `inputIsValid` prop.
 */
function InputLabel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      fontWeight = _ref.fontWeight,
      htmlFor = _ref.htmlFor,
      inputIsValid = _ref.inputIsValid;

  // TODO: Remove className prop, it does not belong here
  var labelClasses = (0, _classnames2.default)(_general2.default.label, _weight2.default[fontWeight]);
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'label',
      { className: labelClasses, htmlFor: htmlFor },
      children
    ),
    inputIsValid && _react2.default.createElement(
      'span',
      { className: _general2.default.icon },
      _react2.default.createElement(_TickSmall2.default, null)
    )
  );
}

InputLabel.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  className: _propTypes2.default.string,
  fontWeight: _propTypes2.default.oneOf(Object.keys(_weight2.default)),
  htmlFor: _propTypes2.default.string,
  inputIsValid: _propTypes2.default.bool
};

InputLabel.defaultProps = {
  inputIsValid: false,
  fontWeight: 'medium'
};

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"general__label___2rwHd fontSize-m lineHeight-s verticalAlign-middle","icon":"general__icon___1Grcy display-inlineBlock marginLeft-xxs verticalAlign-middle"};

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"light":"weight__light___1Gm4I fontWeight-3","regular":"weight__regular___1p5fh fontWeight-4","medium":"weight__medium___1UZaL fontWeight-5","semibold":"weight__semibold___2lX6z fontWeight-6"};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TickSmall;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tick = __webpack_require__(69);

var _tick2 = _interopRequireDefault(_tick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TickSmall(_ref) {
  var size = _ref.size;

  var containerSize = {
    width: size,
    height: size
  };
  var iconSize = {
    width: size / 2,
    height: size / 2
  };
  return _react2.default.createElement(
    'div',
    { className: _tick2.default.container, style: containerSize },
    _react2.default.createElement(
      'svg',
      _extends({}, iconSize, { className: _tick2.default.tick, viewBox: '0 0 8 8' }),
      _react2.default.createElement('path', { d: 'M7.54,1.06a1.2,1.2,0,0,0-1.68.2L3.05,4.37l-1-.76A1.2,1.2,0,0,0,.3,5.19l2,1.6a1.2,1.2,0,0,0,1.85,0l3.6-4a1.2,1.2,0,0,0-.2-1.68' })
    )
  );
}

TickSmall.propTypes = {
  size: _propTypes2.default.number
};

TickSmall.defaultProps = {
  size: 16
};

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"tick__container___1vXxR bg-positive borderRadius-circle display-inlineBlock position-relative","tick":"tick__tick___3MPPt fill-white pinCenter position-absolute"};

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-input-label.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-input-label.js
// module id = 1103
// module chunks = 168707334958949